import { render, staticRenderFns } from "./editTeacher.vue?vue&type=template&id=6be622d2&"
import script from "./editTeacher.vue?vue&type=script&lang=js&"
export * from "./editTeacher.vue?vue&type=script&lang=js&"
import style0 from "./editTeacher.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports